export const requiresView = (target, propertyKey, propertyDescriptor) => {
    const method = propertyDescriptor.value;
    propertyDescriptor.value = function (parameter, callback) {
        if (!this.view) {
            return callback(null, false);
        }
        method.call(this, parameter, callback);
    };
};
